export const parseUserId = (userId: string) => {
  if (!userId) return "";
  const uuidRegex = /([a-f\d]{8}(-[a-f\d]{4}){3}-[a-f\d]{12})/i;
  const match = userId.match(uuidRegex);
  return match ? match[1] : "";
};
